module.exports = __webpack_public_path__ + "static/media/map-pin-fill.b89891b8.svg";